export class EntReservoirFilter {
  page: number;
  size: number;
  name: string| null;
  yearOfConstruction: number| null;
  minDesignCapacity: number| null;
  maxDesignCapacity: number| null;
  createdFrom: string  | null;
  createdTo: string  | null;
  deleted: boolean = false;

  constructor(init?:Partial<EntReservoirFilter>) {
    this.page = 1;
    this.size = 30;
    this.createdTo = null;
    this.createdFrom = null;
    this.name = null;
    this.yearOfConstruction = null;
    this.minDesignCapacity = null;
    this.maxDesignCapacity = null;
    if(init){
      Object.assign(this, init)
    }
    
  }

  
}
